module.exports = __webpack_public_path__ + "img/62.a3016d96.jpg";